import { useMutation } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { openKlantBijlage } from '../services/openKlantBijlage'

export { useOpenKlantBijlage }

const useOpenKlantBijlage = () => {
  const { errorAlert } = useAlerts()

  return useMutation({
    mutationFn: openKlantBijlage,
    onError: (error: any) =>
      errorAlert('Fout bij openen van klant bijlage', error),
  })
}
